import { Message } from 'element-ui'

// export let httpurl = 'https://juzi.job695.com'
export let httpurl = 'https://admin.rltsaas.com'

export const mapkey = 'JKCBZ-SHJCU-LZPV3-2P7JV-LGNBZ-55BKF'
import * as echarts from 'echarts';

//时间换算
export function timeDifference(updateTime) {
	if (updateTime === null) return '';
	updateTime = new Date(updateTime).getTime()
	let now = new Date().getTime() 
	let second = Math.floor((now - updateTime) / (1000)) 
	let minute = Math.floor(second / 60) 
	let hour = Math.floor(minute / 60) 
	let day = Math.floor(hour / 24) 
	let month = Math.floor(day / 31) 
	let year = Math.floor(month / 12) 
	if (year > 0) {
		return year + '年前'
	} else if (month > 0) {
		return month + '月前'
	} else if (day > 0) {
		let ret = day + '天前'
		if (day >= 7 && day < 14) {
			ret = '1周前'
		} else if (day >= 14 && day < 21) {
			ret = '2周前'
		} else if (day >= 21 && day < 28) {
			ret = '3周前'
		} else if (day >= 28 && day < 31) {
			ret = '4周前'
		}
		return ret
	} else if (hour > 0) {
		return hour + '小时前'
	} else if (minute > 0) {
		return minute + '分钟前'
	} else {
		return '刚刚'
	}
	// else if (second > 0) {
	// 	return second + '秒前'
	// }
}

//校验密码强度
export function validatePassword(password){
	const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[a-zA-Z\d]{8,}$/;
	return pattern.test(password);
}

//校验手机号
export function validatePhone(phone){
	const reg = /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/
	return reg.test(phone)
}

export function eltips(text, type = 'info') {
	Message({
		message: text,
		type: type,
		center: true,
		offset: 300,
		duration: 3000
	})
}

export function hasPermissions(permission){
	let allPermissions = JSON.parse(sessionStorage.getItem('userinfo')).all_permissions
	if(allPermissions.indexOf(permission)!=-1){
		return true
	}else{
		return false
	}
}

export function setTimeStyle(time, type) {
	let newTime = new Date(time)
	let y = newTime.getFullYear()
	let m = newTime.getMonth() + 1
	let d = newTime.getDate()
	let h = newTime.getHours()
	let min = newTime.getMinutes()
	let s = newTime.getSeconds()
	if (type) {
		return `${y}-${m<10?'0'+m:m}-${d<10?'0'+d:d} ${h<10?'0'+h:h}:${min<10?'0'+min:min}:${s<10?'0'+s:s}`
	} else {
		return `${y}-${m<10?'0'+m:m}-${d<10?'0'+d:d}`
	}
}

export function parseTime(time, cFormat) {
	if (arguments.length === 0) {
		return null
	}
	const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
	let date
	if (typeof time === 'object') {
		date = time
	} else {
		if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
			time = parseInt(time)
		}
		if (typeof time === 'number' && time.toString().length === 10) {
			time = time * 1000
		}
		date = new Date(time)
	}
	const formatObj = {
		y: date.getFullYear(),
		m: date.getMonth() + 1,
		d: date.getDate(),
		h: date.getHours(),
		i: date.getMinutes(),
		s: date.getSeconds(),
		a: date.getDay()
	}
	const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
		const value = formatObj[key]
		// Note: getDay() returns 0 on Sunday
		if (key === 'a') {
			return ['日', '一', '二', '三', '四', '五', '六'][value]
		}
		return value.toString().padStart(2, '0')
	})
	return time_str
}

//复制
export function copylink(link) {
	let url = link;
	let oInput = document.createElement('input');
	oInput.setAttribute('class', 'copy_index')
	document.body.appendChild(oInput)
	oInput.value = url;
	oInput.select(); // 选择对象;
	document.execCommand("Copy"); // 执行浏览器复制命令
	document.body.removeChild(oInput)
	eltips('复制成功', 'success')
}

//截取url参数
export function getUrlKey(name, url) {
	return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url || window.location.href) || [, ""])[1].replace( /\+/g, '%20')) || null
}

//时间计算
export function formattime(time, time2) {
	if (time < time2) {
		return '时间异常'
	}
	var dateEnd = time; //获取当前时间
	var dateDiff = dateEnd - time2; //时间差的毫秒数
	var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
	var leave1 = dateDiff % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
	var hours = Math.floor(leave1 / (3600 * 1000)) //计算出小时数
	if (hours < 10) {
		hours = '0' + hours
	}
	//计算相差分钟数
	var leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
	var minutes = Math.floor(leave2 / (60 * 1000)) //计算相差分钟数
	if (minutes < 10) {
		minutes = '0' + minutes
	}
	//计算相差秒数
	var leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
	var seconds = Math.round(leave3 / 1000)
	if (seconds < 10) {
		seconds = '0' + seconds
	}
	var timeFn
	if (dayDiff > 1) {
		timeFn = dayDiff + "天" + hours + ":" + minutes + ":" + seconds;
	} else {
		timeFn = hours + ":" + minutes + ":" + seconds;
	}
	return timeFn;
}

//去除对象或数组中的空值('',null,undefined,[],{})
export function removeEmptyField(obj) {
	var newObj = {}
	if (typeof obj === 'string') {
		obj = JSON.parse(obj)
	}
	if (obj instanceof Array) {
		newObj = []
	}
	if (obj instanceof Object) {
		for (var attr in obj) {
			// 属性值不为'',null,undefined才加入新对象里面(去掉'',null,undefined)
			if (obj.hasOwnProperty(attr) && obj[attr] !== '' && obj[attr] !== null && obj[attr] !== undefined) {
				if (obj[attr] instanceof Object) {
					// 空数组或空对象不加入新对象(去掉[],{})
					if (JSON.stringify(obj[attr]) === '{}' || JSON.stringify(obj[attr]) === '[]') {
						continue
					}
					// 属性值为对象,则递归执行去除方法
					newObj[attr] = removeEmptyField(obj[attr])
				} else if (
					typeof obj[attr] === 'string' &&
					((obj[attr].indexOf('{') > -1 && obj[attr].indexOf('}') > -1) ||
						(obj[attr].indexOf('[') > -1 && obj[attr].indexOf(']') > -1))
				) {
					// 属性值为JSON时
					try {
						var attrObj = JSON.parse(obj[attr])
						if (attrObj instanceof Object) {
							newObj[attr] = removeEmptyField(attrObj)
						}
					} catch (e) {
						newObj[attr] = obj[attr]
					}
				} else {
					newObj[attr] = obj[attr]
				}
			}
		}
	}
	return newObj
}

export function getdate(time) {
	var now = new Date(time),
		y = now.getFullYear(),
		m = ("0" + (now.getMonth() + 1)).slice(-2),
		d = ("0" + now.getDate()).slice(-2);
	return y + "-" + m + "-" + d + " ";
}

//时间格式化
export function dateFormat(date) {
	Date.prototype.Format = function(fmt) {
		var o = {
			'M+': this.getMonth() + 1, // 月份
			'd+': this.getDate(), // 日
			'h+': this.getHours(), // 小时
			'm+': this.getMinutes(), // 分
			's+': this.getSeconds(), // 秒
			'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
			S: this.getMilliseconds() // 毫秒
		};
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
		for (var k in o)
			if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : (
				'00' + o[k]).substr(
				('' + o[k]).length));
		return fmt;
	};

	return (date || new Date()).Format('yyyy-MM-dd hh:mm:ss')
}

//echar 折线图
export function setEchartLine(option) {
	let echar = echarts.init(document.getElementById(option.el_id))
	echar.setOption({
		tooltip: {
			trigger: 'axis',
		},
		grid: {
			left: '3%',
			right: '3%',
			bottom: '5%',
		},
		xAxis: {
			type: 'category',
			boundaryGap: false,
			axisTick: {
				alignWithLabel: true
			},
			data: option.x_data
		},
		yAxis: {
			type: 'value',
			minInterval: 1,
			splitLine: {
				show: true,
				lineStyle: {
					color: ['#e9edef'],
					width: 1,
					type: 'solid'
				}
			},
		},

		series: [{
			name: '',
			type: 'line',
			smooth: true,
			stack: '数量',
			data: option.y_data,
			symbolSize: 10,
			areaStyle: {
				normal: {
					color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
						offset: 0,
						color: option.lineColor1 || 'rgba(135,154,255,1)' // 0% 处的颜色
					}, {
						offset: 0.5,
						color: option.lineColor2 || 'rgba(135,154,255,.5)' // 50% 处的颜色
					}, {
						offset: 1,
						color: option.lineColor3 || 'rgba(135,154,255,.2)' // 100% 处的颜色
					}])
				}
			},
			itemStyle: {
				normal: {
					color: option.color || '#4a67ff', //改变折线点的颜色
					lineStyle: {
						color: option.color || '#4a67ff' //改变折线颜色
					}
				}
			},
		}]
	})


	setTimeout(() => {
		window.onresize = function() {
			echar.resize();
		}
	}, 200)
}

// 圆饼
export function setEchartCircular(option) {
	let echar = echarts.init(document.getElementById(option.el_id))
	echar.setOption({
		series: [{
			type: 'pie',
			data: [{
					value: 335,
					name: '直接访问'
				},
				{
					value: 234,
					name: '联盟广告'
				},
				{
					value: 1548,
					name: '搜索引擎'
				}
			]
		}]
	})


	setTimeout(() => {
		window.onresize = function() {
			echar.resize();
		}
	}, 200)
}

// 空心圆饼
export function setEchartHollow(option) {
	console.log(option, 'option')
	let echar = echarts.init(document.getElementById(option.el_id))
	echar.setOption({
		tooltip: {
			trigger: 'item'
		},
		grid: {
			x: 0,
			y: 0
		},
		legend: {
			// x: 'center',
			y: '80%',
			textStyle: {
				color: '#5A607F',
				// fontSize: '40px',
			}
		},
		color: ['#1E5EFF', '#B539FC', '#1FD286', '#0EF7FF', '#FFC700'],
		series: [{
			type: 'pie',
			radius: '70%',
			center: ['50%', '40%'],
			avoidLabelOverlap: false,
			label: {
				show: false,
				position: 'center'
			},
			emphasis: {
				label: {
					show: false,
					fontSize: '20',
					fontWeight: 'bold'
				}
			},
			labelLine: {
				show: false
			},
			data: option.option,
		}]
	})
	setTimeout(() => {
		window.onresize = function() {
			echar.resize();
		}
	}, 200)
}

//圆柱
export function setEchartCylinder(option) {
	let echar = echarts.init(document.getElementById(option.el_id))
	echar.setOption({
		xAxis: {
			type: 'category',
			show: false,
		},
		yAxis: {
			type: 'value',
			show: false,
		},
		splitLine: {
			show: false
		},
		axisLine: {
			show: false
		}, //不显示坐标轴
		grid: {
			top: 20,
			left: 0,
			width: 130,
			height: 88,
			tooltip: { //---鼠标焦点放在图形上，产生的提示框
				show: true,
				trigger: 'item', //---触发类型
				textStyle: {
					color: '#ffffff',
				},
			}
		},
		color: [option.color],
		tooltip: {
			show: true, //---是否显示提示框,默认为true
		},
		series: [{
			data: [
				120,
				{
					value: 200,
					itemStyle: {
						color: '#1E92FF'
					}
				},
				150,
				80,
				70,
				110
			],
			type: 'bar',
			barWidth: 18,
			itemStyle: {
				normal: {
					//这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
					barBorderRadius: [4, 4, 0, 0]
				}
			}
		}],
	})
	setTimeout(() => {
		window.onresize = function() {
			echar.resize();
		}
	}, 200)
}

//圆柱二(财务)
export function setEchartCylinder2(option) {
	let echar = echarts.init(document.getElementById(option.el_id))
	echar.setOption({
		xAxis: {
			type: 'category',
			show: true,
			axisLine: { //---坐标轴 轴线
				show: false, //---是否显示
			},
			axisTick: { //--网格区域
				show: false, //---是否显示，默认false
			},
			splitArea: { //--网格区域
				show: false, //---是否显示，默认false
			},
			nameTextStyle: { //---坐标轴名称样式
				color: "#000",
				padding: [5, 0, 0, 5], //---坐标轴名称相对位置
			},

			data: option.data || ['今日', '昨日', '七日', '30日'], //内容
		},
		yAxis: {
			type: 'value',
			show: false,
		},
		splitLine: {
			show: false
		},
		axisLine: {
			show: false
		}, //不显示坐标轴
		grid: {
			top: 20,
			left: 0,
			width: option.width || 240,
			height: 88,
			tooltip: { //---鼠标焦点放在图形上，产生的提示框
				show: true,
				trigger: 'item', //---触发类型
				textStyle: {
					color: '#ffffff',
				},
			}
		},
		label: {
			show: true,
			position: 'top',
			color: '#000',
		},
		color: ['#1E92FF'],
		tooltip: {
			show: true, //---是否显示提示框,默认为true
		},
		series: [{
			data: option.option,
			type: 'bar',
			barMinHeight: 3,
			barWidth: 30,
			itemStyle: {
				normal: {
					//这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
					barBorderRadius: [4, 4, 4, 4]
				}
			}
		}],
	})
	setTimeout(() => {
		window.onresize = function() {
			echar.resize();
		}
	}, 200)
}

// 饼状图
export function setEchartCake(option) {

	let echar = echarts.init(document.getElementById(option.el_id))

	echar.setOption({
		legend: {
			orient: 'vertical',
			left: 'left',
			bottom: 15,
			itemGap: 24,
			itemWidth: 8,
			itemHeight: 8,
			textStyle: { //图例中文字的样式
				color: '#000',
				fontSize: 14
			},
		},
		color: ['#A4BEFF', '#FFE600', '#EDA4FF', '#1989fa', '#00ff00', '#ff6600', '#FF00FF', '#6A5ACD',
			'#F08080', '#00FF7F'
		], //饼图中各模块的颜色
		series: [{
			type: 'pie',
			radius: option.radius || '65%',
			center: option.center || ['65%', '50%'], //整个饼图在整个父元素中的位置
			data: option.option,
			minAngle: 0, //设置扇形的最小占比
			emphasis: {
				itemStyle: {
					shadowBlur: 10,
					shadowOffsetX: 0,
					shadowColor: 'rgba(0, 0, 0, 0.5)'
				}
			},
			label: {
				show: !option.seriesLabelShow || false
			}
		}]
	})

	setTimeout(() => {
		window.onresize = function() {
			echar.resize();
		}
	}, 200)
}

//看板统计
export function setMapEcharts(option) {
	let echar = echarts.init(document.getElementById(option.el))

	let echarOption = {
		title: option.title?option.title : { show:false },
		tooltip: { 
			show: true ,
			confine: true
		},
		legend: option.legend?option.legend : { show: false },
		grid: {
			left:0,
			right:0,
			top:0,
			bottom:0,
			borderWidth:'0',
			containLabel: true,
		},
		xAxis: {
			show: false
		},
		series: option.series
	}
	
	if(option.series[0].type=='bar'){
		echarOption.yAxis = {
			borderwidth:0,
			axisLabel:{
				show: true,
				interval: 0,
				textStyle:{
					color:'#FFFFFF',
					fontSize:'14'
				},
				formatter:function(value){
					var texts=value;
					if(texts.length>6){ // 具体多少字就看自己了
						texts=texts.substr(0,5)+'....';
					}
					return texts;
				}
			},
			type: 'category',
			data: option.y ? option.y.data : []
		}
	}
	
	if(option.series[0].type=='line'){
		echarOption.xAxis = option.xAxis
		echarOption.grid.top = '10'
		echarOption.grid.bottom = '10'
		echarOption.grid.right = '10'
		echarOption.yAxis = {
		    type: 'value',
			axisLabel: {
				textStyle: {
					color: '#FFFFFF',
				}
			},
		}
	}
	
	echar.setOption(echarOption)
}

import * as qiniu from 'qiniu-js'
import axios from 'axios'
const qiniuUrl = 'https://qiniu.job695.com/'
const IMAGE_MAX_SIZE = 2 * 1024 * 1024
export function qiniuUpload(file,key,token){
	return new Promise((resolve)=> {
		const observable = qiniu.upload(file, key, token)
		const observer = {
			error(err) {
				console.error('七牛云上传失败------',err)
				resolve(false)
			},
			complete(res) {
				resolve(qiniuUrl + res.key)
			}
		}
		observable.subscribe(observer);
	})
}

function canvasToFile(canvas, file, quality) {
	return new Promise((resolve) => {
		canvas.toBlob((blob) => {
			if (!blob) return resolve(file)
			const name = file.name.replace(/\.\w+$/, '.jpg')
			resolve(new File([blob], name, {
				type: 'image/jpeg',
				lastModified: Date.now()
			}))
		}, 'image/jpeg', quality)
	})
}

//压缩图片，默认不超过2M
export function compressImage(file, maxSize = IMAGE_MAX_SIZE) {
	return new Promise((resolve) => {
		if (!(file instanceof File) || !file.type.startsWith('image/')) {
			resolve(file)
			return
		}
		if (file.size <= maxSize) {
			resolve(file)
			return
		}
		const img = new Image()
		const objectUrl = URL.createObjectURL(file)
		img.onload = async () => {
			URL.revokeObjectURL(objectUrl)
			let width = img.width
			let height = img.height
			const maxSide = 1920
			if (width > maxSide || height > maxSide) {
				const ratio = Math.min(maxSide / width, maxSide / height)
				width = Math.round(width * ratio)
				height = Math.round(height * ratio)
			}
			const canvas = document.createElement('canvas')
			const ctx = canvas.getContext('2d')
			let quality = 0.9
			let result = file
			const draw = () => {
				canvas.width = width
				canvas.height = height
				ctx.fillStyle = '#fff'
				ctx.fillRect(0, 0, width, height)
				ctx.drawImage(img, 0, 0, width, height)
			}
			while (quality >= 0.4) {
				draw()
				result = await canvasToFile(canvas, file, quality)
				if (result.size <= maxSize) break
				quality = Number((quality - 0.1).toFixed(1))
			}
			while (result.size > maxSize && width > 400) {
				width = Math.round(width * 0.8)
				height = Math.round(height * 0.8)
				draw()
				result = await canvasToFile(canvas, file, 0.7)
			}
			resolve(result)
		}
		img.onerror = () => {
			URL.revokeObjectURL(objectUrl)
			resolve(file)
		}
		img.src = objectUrl
	})
}

export function compressImages(files, maxSize = IMAGE_MAX_SIZE) {
	const list = files ? Array.from(files) : []
	if (!list.length) return Promise.resolve([])
	return Promise.all(list.map(file => compressImage(file, maxSize)))
}

//上传图片至服务器
export function uploadFileToService(file){
	return new Promise(async (resolve) => {
		if (!file || !(file instanceof File) || !file.type.startsWith('image/')) {
			eltips('仅支持图片格式', 'error')
			resolve(false)
			return
		}
		const compressed = await compressImage(file)
		if (compressed.size > IMAGE_MAX_SIZE) {
			eltips('图片过大，压缩后仍超过2M', 'error')
			resolve(false)
			return
		}
		const formData = new FormData()
		formData.append('file', compressed)
		axios.post('https://insure.rltsaas.com/api/File/upload', formData).then(res => {
			if (res.code == 200) {
				resolve(res.url)
			} else {
				eltips(res.msg || '上传失败', 'error')
				resolve(false)
			}
		}).catch(err => {
			console.error('上传失败------', err)
			eltips('上传失败', 'error')
			resolve(false)
		})
	})
}

//批量上传图片至服务器
export function uploadFilesToService(files){
	const list = files ? Array.from(files) : []
	if (!list.length) return Promise.resolve([])
	return Promise.all(list.map(file => uploadFileToService(file)))
}